import { useEffect } from "react";
import Lenis from "lenis";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import VideoSection from "./components/VideoSection";
import Problem from "./components/Problem";
import Reframe from "./components/Reframe";
import Path from "./components/Path";
import BonusOffer from "./components/BonusOffer";
import Inside from "./components/Inside";
import Skool from "./components/Skool";
import Faq from "./components/Faq";
import FinalCta from "./components/FinalCta";
import StickyBar from "./components/StickyBar";

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="bg-ink text-cream font-sans antialiased">
      <div className="noise" aria-hidden="true" />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <VideoSection />
        <Problem />
        <Reframe />
        <Path />
        <BonusOffer />
        <Inside />
        <Skool />
        <Faq />
        <FinalCta />
      </main>
      <StickyBar />
    </div>
  );
}
